import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Input,
  InputAdornment,
  Typography
} from '@material-ui/core';
import './CustomTextInput.css';

class CustomTextInput extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      fieldValue: this.props.selectedValue,
      startingValue: this.props.selectedValue
    };

    this.getLabelText = this.getLabelText.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProp) {
    if (prevProp.selectedValue !== this.props.selectedValue) {
      this.setState({
        fieldValue: this.props.selectedValue,
        startingValue: this.props.selectedValue
      });
    }
  }

  handleChange(value) {
    this.setState({ fieldValue: value });
  }

  getLabelText(option) {
    switch (option.value) {
      case this.props.initialValue:
        return `${option.label} (Current)`;
      case this.props.value:
        return `${option.label} (New)`;
      default:
        return option.label;
    }
  }

  render() {
    const startAdornment = !!this.props.startAdornment
      ? this.props.startAdornment
      : '';
    const endAdornment = !!this.props.endAdornment
      ? this.props.endAdornment
      : '';

    return (
      <FormControl fullWidth className="custom-text-input">
        <div className="row">
          <div className="col-xs-12">
            <Typography type="body2" gutterBottom align="left">
              {this.props.labelText}
            </Typography>
          </div>
        </div>
        <div className="value-wrapper">
          <div
            className={
              this.props.initialValue !== this.props.selectedValue
                ? 'changed-initial-textfield'
                : ''
            }
          >
            {`${startAdornment}${this.props.initialValue}${endAdornment}`}
          </div>
          &nbsp;&nbsp;
          {this.props.disabled &&
          this.props.initialValue !== this.props.selectedValue ? (
            <div
              className={this.props.approvalRequired ? 'adjustment-text' : ''}
            >
              {`${startAdornment}${this.props.selectedValue}${endAdornment}`}
            </div>
          ) : null}
        </div>
        {this.props.disabled ? null : (
          <Input
            className="text-input-field"
            fullWidth
            value={this.state.fieldValue}
            onChange={(event) => this.handleChange(event.target.value)}
            onBlur={() => {
              if (this.props.isValidChange(this.state.fieldValue)) {
                this.props.onBlur(this.state.fieldValue);
              } else {
                this.setState({
                  fieldValue: this.state.startingValue
                });
              }
            }}
            startAdornment={
              <InputAdornment position="start">
                {!!this.props.startAdornment ? this.props.startAdornment : ''}
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="start">
                {!!this.props.endAdornment ? this.props.endAdornment : ''}
              </InputAdornment>
            }
          />
        )}
      </FormControl>
    );
  }
}

CustomTextInput.propTypes = {
  initialValue: PropTypes.any,
  selectedValue: PropTypes.any,
  labelText: PropTypes.string,
  handleChange: PropTypes.func,
  startAdornment: PropTypes.string,
  endAdornment: PropTypes.string,
  disabled: PropTypes.bool,
  approvalRequired: PropTypes.bool,
  onBlur: PropTypes.func
};

export default CustomTextInput;
